/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import { eachDayOfInterval, eachWeekOfInterval, eachMonthOfInterval, eachQuarterOfInterval, eachYearOfInterval, format, getDate, getWeek, getMonth, getQuarter, getYear } from 'date-fns'
 
let generateData = (start_date_string, end_date_string, resolution, data) => {
    let intervals = generateIntervals(start_date_string, end_date_string, resolution)
    let resolved_interval = addResolutionToIntervals(intervals, resolution)
    let chart_data = {}
    chart_data.data = generateChartData(resolved_interval, data, resolution)
    chart_data.charts = []
    return chart_data
}

let generateIntervals = (start_date_string, end_date_string, resolution) => {
    let intervals
    switch (resolution) {
        case "Daily":
            intervals = eachDayOfInterval({start: new Date(start_date_string), end : new Date (end_date_string)})
            return intervals
        
        case "Weekly":
            intervals = eachWeekOfInterval({start: new Date(start_date_string), end : new Date (end_date_string)})
            return intervals

        case "Monthly":
            intervals = eachMonthOfInterval({start: new Date(start_date_string), end : new Date (end_date_string)})
            return intervals

        case "Quarterly":
            intervals = eachQuarterOfInterval({start: new Date(start_date_string), end : new Date (end_date_string)})
            return intervals

        case "Yearly":
            intervals = eachYearOfInterval({start: new Date(start_date_string), end : new Date (end_date_string)})
            return intervals
              
        default:
            return intervals    
    }
}

let addResolutionToIntervals = (intervals, resolution) => {
    let formatted_intervals = intervals.map(interval => {
        let int_obj = {}
        int_obj.date_time = formatResolution(interval, resolution)
        int_obj.date_time_break_up = {}
        int_obj.date_time_break_up.day = getDate(interval)
        int_obj.date_time_break_up.week = getWeek(interval)
        int_obj.date_time_break_up.month = getMonth(interval) + 1
        int_obj.date_time_break_up.quarter = getQuarter(interval)
        int_obj.date_time_break_up.year = getYear(interval)
        return int_obj
    })

    return formatted_intervals
}

let formatResolution = (date, resolution) => {
    let formatted_string

    if (resolution === "Daily") {
        formatted_string = format(date, "dd/MM/yy")
    }

    if (resolution === "Weekly") {
        formatted_string = format(date, "ww/yyyy")
    }

    if (resolution === "Monthly") {
        formatted_string = format(date, "MMM yy")
    }

    if (resolution === "Quarterly") {
        formatted_string = format(date, "'Q'Q yy")
    }

    if (resolution === "Yearly") {
        formatted_string = format(date, "yyyy")
    }

    return formatted_string
}

let generateChartData = (resolved_intervals, data, resolution) => {
    let chart_data = resolved_intervals.map(interval => {
        let record = []
        data.map(el => {
            if (resolution === 'Daily') {
                if (el.day_of_month === interval.date_time_break_up.day && el.month_of_year === interval.date_time_break_up.month && el.year === interval.date_time_break_up.year){
                    record.push(el)
                }
            }

            if (resolution === 'Weekly') {
                if (el.week_of_year === interval.date_time_break_up.week && el.year === interval.date_time_break_up.year){
                    record.push(el)
                }
            }
    
            if (resolution === 'Monthly') {
                if (el.month_of_year === interval.date_time_break_up.month && el.year === interval.date_time_break_up.year) {
                    record.push(el)
                }
            }
    
            if (resolution === 'Quarterly') {
                if (el.qtr_of_year === interval.date_time_break_up.quarter && el.year === interval.date_time_break_up.year) {
                    record.push(el)
                }
            }
    
            if (resolution === 'Yearly') {
                if (el.year === interval.date_time_break_up.year) {
                    record.push(el)
                }
            }
        })
        interval.record = record
        return interval
    })

    return chart_data
}




export default generateData